import React from 'react';
import { Link } from 'react-router-dom';
import logocontablog from '../images/logo.png';
import './blog.css';

const HeaderBlog = () => {
  return (
    <header className='blog-topbar-main-blog'>
      <div className='blog-brand'>
        <img src={logocontablog} alt='ContaLearn logo' className='blog-brand-logo' />
        <span className='blog-brand-name'>blog</span>
      </div>

      <nav className='blog-nav'>
        <Link to='/home' className='blog-nav-link'>Home</Link>
        <a href='#authors' className='blog-nav-link'>Autori</a>
        <a href='#posts' className='blog-nav-link'>Articole</a>
        <Link to='/functionalpagelogin' className='blog-nav-cta'>
          CONTINUA SA INVETI
        </Link>
      </nav>
    </header>
  );
};

export default HeaderBlog;
